var map = {
	"./ar.json": [
		"d76e",
		"legal-ar-json"
	],
	"./de.json": [
		"5232",
		"legal-de-json"
	],
	"./en.json": [
		"82a1",
		"legal-en-json"
	],
	"./es.json": [
		"0391",
		"legal-es-json"
	],
	"./fr.json": [
		"42ff",
		"legal-fr-json"
	],
	"./pt.json": [
		"2ca5",
		"legal-pt-json"
	],
	"./ru.json": [
		"a3ad",
		"legal-ru-json"
	],
	"./tr.json": [
		"82b7",
		"legal-tr-json"
	],
	"./ua.json": [
		"300f",
		"legal-ua-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8133";
module.exports = webpackAsyncContext;